<div class="divider">
    <div class="flex flex-row items-center gap-5"><span i18n>Attribute</span></div>
    <button
        class="btn btn-sm btn-circle btn-ghost btn-primary tooltip"
        i18n-data-tip
        data-tip="Show/Hide the real attribute name"
        (click)="showRealAttributeName = !showRealAttributeName"
    >
        <iota-icon icon="code-bracket" [ngClass]="{ 'text-primary': showRealAttributeName }"></iota-icon>
    </button>
    <button
        class="btn btn-sm btn-circle btn-ghost btn-primary tooltip"
        i18n-data-tip
        data-tip="Download attributes as Excel file"
        (click)="exportAttributes()"
        *ngIf="attributes && attributes.length > 0"
    >
        <iota-icon icon="arrow-down-tray"></iota-icon>
    </button>
    <button
        class="btn btn-sm btn-circle btn-ghost btn-primary tooltip"
        i18n-data-tip
        data-tip="Import attributes from Excel file"
        (click)="importAttributes()"
        *ngIf="editMode"
    >
        <iota-icon icon="arrow-up-tray"></iota-icon>
    </button>
</div>
<div class="flex flex-col gap-2 overflow-x-visible">
    <ng-container *ngIf="additionalInformationTemplate">
        <ng-container *ngTemplateOutlet="additionalInformationTemplate"></ng-container>
    </ng-container>
    <div class="flex flex-row items-center justify-end text-xs font-bold text-iota-required-attribute" i18n>* required information</div>
    <div class="flex flex-col gap-2 overflow-x-visible" *ngFor="let section of attributeSections; trackBy: trackByAttributeSection">
        <div class="collapse collapse-arrow border">
            <input type="checkbox" />
            <div class="collapse-title">
                <div class="flex flex-row items-center gap-5">
                    <span class="font-bold text-base text-primary">{{ section?.label }}</span>
                    <div class="flex flex-row items-center gap-2">
                        <div
                            class="badge badge-accent"
                            *ngIf="showNumberOfAttributesWithThisParentIdBadge && section?.numberOfAttributesWithThisParentId > 0"
                        >
                            {{ section?.numberOfAttributesWithThisParentId }}&nbsp;<span>{{
                                numberOfAttributesWithThisParentIdBadgeSuffix
                            }}</span>
                        </div>

                        <ng-container *ngIf="editMode">
                            <div class="badge badge-success" *ngIf="numberOfUpsertedByCategory.get(section?.key)">
                                {{ numberOfUpsertedByCategory.get(section?.key) }}&nbsp;<span i18n>modified</span>
                            </div>
                            <div class="badge badge-error" *ngIf="numberOfDeletedByCategory.get(section?.key)">
                                {{ numberOfDeletedByCategory.get(section?.key) }}&nbsp;<span i18n>deleted</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="collapse-content flex flex-col gap-1">
                <div
                    class="flex flex-row items-center mb-3"
                    *ngIf="editMode && section?.key === otherAttributesKey && (isIotaAdmin$ | ngrxPush)"
                    (click)="addAttribute(section?.key)"
                >
                    <button class="btn btn-accent flex flex-row items-center gap-2">
                        <iota-icon icon="plus"></iota-icon>
                        <span i18n>Add attribute</span>
                    </button>
                </div>
                <div class="w-full text-center" *ngIf="section?.groups?.length === 0"><i i18n>No attribute available</i></div>
                <div class="flex flex-col" *ngFor="let attributeGroup of section?.groups">
                    <ng-container *ngIf="attributeGroup.simpleAttribute">
                        <app-simplified-attribute
                            *ngFor="let previousAndCurrentAttribute of attributeGroup.previousAndCurrentAttributes; let i = index"
                            [iotaConfigAttribute]="attributeGroup.iotaConfigAttribute"
                            [previousAttribute]="previousAndCurrentAttribute.previousAttribute"
                            [currentAttribute]="previousAndCurrentAttribute.currentAttribute"
                            [hideTitleAndValueType]="i !== 0"
                            [editMode]="editMode"
                            [locales]="attributeGroup?.unusedLocales"
                            [selectedLanguage]="selectedLanguage$ | ngrxPush"
                            [parentId]="parentId"
                            [markIfParentIdIsThisParentId]="markIfParentIdIsThisParentId"
                            [overridesOtherAttributeTooltip]="overridesOtherAttributeTooltip"
                            [parentIdIsThisParentIdTooltip]="parentIdIsThisParentIdTooltip"
                            (removeAttribute)="removeAttribute(attributeGroup, previousAndCurrentAttribute)"
                            (updateMarkForDeleteValue)="modifyDeleteNumber(section?.key, $event)"
                            (updateMarkForUpsertValue)="modifyUpsertNumber(section?.key, $event)"
                            [showRealAttributeName]="showRealAttributeName"
                            #simpleAttributeElement
                        ></app-simplified-attribute
                    ></ng-container>
                    <ng-container *ngIf="!attributeGroup.simpleAttribute">
                        <app-attribute-v2
                            *ngFor="let previousAndCurrentAttribute of attributeGroup.previousAndCurrentAttributes; let i = index"
                            [previousAttribute]="previousAndCurrentAttribute.previousAttribute"
                            [currentAttribute]="previousAndCurrentAttribute.currentAttribute"
                            [hideTitleAndValueType]="i !== 0"
                            [locales]="attributeGroup?.unusedLocales"
                            [usedAttributeNames]="usedAttributeNames"
                            [editMode]="editMode"
                            [parentId]="parentId"
                            [markIfParentIdIsThisParentId]="markIfParentIdIsThisParentId"
                            [overridesOtherAttributeTooltip]="overridesOtherAttributeTooltip"
                            [parentIdIsThisParentIdTooltip]="parentIdIsThisParentIdTooltip"
                            (removeAttribute)="removeAttribute(attributeGroup, previousAndCurrentAttribute)"
                            (updateMarkForDeleteValue)="modifyDeleteNumber(section?.key, $event)"
                            (updateMarkForUpsertValue)="modifyUpsertNumber(section?.key, $event)"
                            #complexAttributeElement
                        ></app-attribute-v2>
                    </ng-container>
                    <div
                        class="flex flex-row items-center justify-end mb-3"
                        *ngIf="
                            editMode &&
                            !!attributeGroup.previousAndCurrentAttributes?.[0] &&
                            attributeGroup?.unusedLocales?.length > 0 &&
                            attributeGroup.addPossible
                        "
                        (click)="addLocale(attributeGroup)"
                    >
                        <button class="btn btn-sm btn-primary flex flex-row items-center gap-2">
                            <iota-icon icon="plus"></iota-icon>
                            <span i18n>Add translation</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
